import { isNetworkError } from './errors';

export const SHIPPING_RATE_ERROR = Object.freeze({
  ADDRESS_INVALID: 'SHIPPING_ADDRESS_INVALID',
  SELLER_CONFIGURATION: 'SELLER_SHIPPING_CONFIGURATION',
  PARCEL_CONFIGURATION: 'PARCEL_CONFIGURATION_INVALID',
  NO_OPTIONS: 'NO_SHIPPING_OPTIONS',
  TEMPORARY: 'SHIPPING_RATE_TEMPORARY',
  NETWORK: 'SHIPPING_RATE_NETWORK',
  UNKNOWN: 'SHIPPING_RATE_UNKNOWN',
});

const ERROR_DEFINITIONS = Object.freeze({
  [SHIPPING_RATE_ERROR.ADDRESS_INVALID]: {
    type: 'address',
    messageId: 'CheckoutPage.shippingRateErrorAddress',
    action: 'edit_address',
    retryable: false,
  },
  [SHIPPING_RATE_ERROR.SELLER_CONFIGURATION]: {
    type: 'seller_configuration',
    messageId: 'CheckoutPage.shippingRateErrorSellerConfiguration',
    action: 'contact_seller',
    retryable: false,
  },
  [SHIPPING_RATE_ERROR.PARCEL_CONFIGURATION]: {
    type: 'parcel_configuration',
    messageId: 'CheckoutPage.shippingRateErrorParcelConfiguration',
    action: 'contact_seller',
    retryable: false,
  },
  [SHIPPING_RATE_ERROR.NO_OPTIONS]: {
    type: 'no_options',
    messageId: 'CheckoutPage.shippingRateErrorNoOptions',
    action: 'edit_address',
    retryable: false,
  },
  [SHIPPING_RATE_ERROR.TEMPORARY]: {
    type: 'temporary',
    messageId: 'CheckoutPage.shippingRateErrorTemporary',
    action: 'retry',
    retryable: true,
  },
  [SHIPPING_RATE_ERROR.NETWORK]: {
    type: 'network',
    messageId: 'CheckoutPage.shippingRateErrorNetwork',
    action: 'retry',
    retryable: true,
  },
  [SHIPPING_RATE_ERROR.UNKNOWN]: {
    type: 'unknown',
    messageId: 'CheckoutPage.shippingRateErrorUnknown',
    action: 'retry',
    retryable: true,
  },
});

const getBackendDetails = error => error?.data?.details || error?.details || {};

export const normalizeShippingRateError = error => {
  const backendDetails = getBackendDetails(error);
  const backendCode = error?.data?.code || error?.code;
  const status = Number(error?.status || error?.statusCode || 0);
  const code = isNetworkError(error)
    ? SHIPPING_RATE_ERROR.NETWORK
    : [
        'MISSING_SHIPPING_DETAILS',
        'INVALID_ADDRESS_REQUEST',
        'SHIPPO_VALIDATION_ERROR',
        'SHIPPO_INVALID_ADDRESS',
      ].includes(backendCode)
    ? SHIPPING_RATE_ERROR.ADDRESS_INVALID
    : ERROR_DEFINITIONS[backendCode]
    ? backendCode
    : [429, 502, 503, 504].includes(status)
    ? SHIPPING_RATE_ERROR.TEMPORARY
    : SHIPPING_RATE_ERROR.UNKNOWN;
  const definition = ERROR_DEFINITIONS[code];

  return {
    type: backendDetails.type || definition.type,
    code,
    messageId: definition.messageId,
    action: backendDetails.action || definition.action,
    retryable:
      typeof backendDetails.retryable === 'boolean'
        ? backendDetails.retryable
        : definition.retryable,
    status: status || null,
    technicalDetails: {
      originalCode: backendCode || null,
      originalMessage: error?.message || error?.statusText || null,
      status: status || null,
    },
  };
};

export const buildNoShippingOptionsError = () =>
  normalizeShippingRateError({
    code: SHIPPING_RATE_ERROR.NO_OPTIONS,
    data: {
      code: SHIPPING_RATE_ERROR.NO_OPTIONS,
      details: ERROR_DEFINITIONS[SHIPPING_RATE_ERROR.NO_OPTIONS],
    },
  });
